/*
 * @Author: Teemo Ding
 * @Date: 2021-07-22 16:51:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-13 17:12:47
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PackingSlip/config.tsx
 */
import React from 'react';
import css from './css.module.less';
export const breadcrumbData = (warehouseName, warehouseUuid, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/logistics',
    name: getI18n('storeLogistics.config.logistics'),
  },
  {
    url: `/settings/logistics/warehouselocation/setting/${warehouseUuid}`,
    name: warehouseName,
  },
  {
    url: '',
    name: getI18n('storeLogistics.warehouseLocations.packingSlip'),
  },
];

export const columns = (deleteInformation, editInformation, { getI18n }) => [
  {
    title: getI18n('storeLogistics.packingSlip.information'),
    dataIndex: 'information',
    default: true,
    optional: true,
    key: 'information',
    className: css.columnClass,
    minWidth: 300,
    childGenerate: (text, record) => (
      <div className={css.informationContain}>
        <div className={css.informationTitle}>{record.title}</div>
        <div>{record.content}</div>
      </div>
    ),
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'actions',
    default: true,
    optional: true,
    key: 'actions',
    className: css.columnClass,
    width: 126,
    align: 'center',
    childGenerate: (text, record) => (
      <div className={css.actionContain}>
        <div
          className={css.delete}
          onClick={() => {
            deleteInformation(record);
          }}>
          {getI18n('general.delete')}
        </div>
        <div className={css.edit} onClick={() => editInformation(record)}>
          {getI18n('general.edit')}
        </div>
      </div>
    ),
  },
];
